// extracted by mini-css-extract-plugin
export var authorBioEditorialAbout = "J_ck";
export var authorBioEditorialContainer = "J_cj";
export var authorBioEditorialXp = "J_cl";
export var authorBioPageContainer = "J_ch";
export var relatedArticles = "J_B";